import React from 'react'
import Modal from 'react-modal'
import { ButtonMedium, style } from 'app/assets/styles'
import { useIntl } from 'react-intl'
import { H6, Spacer, colors } from 'app-v2/design-systems'
import { COLOR, SIZE, SPACING } from 'app-v2/design-tokens'
import styled from 'styled-components'
import { Info } from 'app/assets/icons'
import { Text } from 'app/common/typography'
import { AccountInformation } from './AccountInformation'

type DeleteAccountModalProps = {
    onCancel?: () => void,
    onDeleteConfirm?: () => void
    //$FlowFixMe
} & Modal.Props
export const DeleteAccountModal = ({
    onCancel,
    onDeleteConfirm,
    ...modalProps
}: DeleteAccountModalProps) => {
    const intl = useIntl()

    return (
        <Modal {...modalProps} style={style.classicModalStyle}>
            <StyledContainer>
                <H6>
                    {intl.formatMessage({
                        id: 'kingdom.profile.form.delete.account.title'
                    })}
                </H6>

                <Spacer size={SIZE.L} />

                <StyledInfoContainer>
                    <StyledIconContainer>
                        <Info color={COLOR.PRIMARY} size={32} />
                    </StyledIconContainer>

                    <StyledInfoTextContainer>
                        <Text>
                            {intl.formatMessage({
                                id: 'kingdom.profile.form.delete.account.infos'
                            })}
                        </Text>
                    </StyledInfoTextContainer>
                </StyledInfoContainer>

                <Spacer size={SIZE.L} />

                <AccountInformation />

                <Spacer size={SIZE.XL} />

                <StyledButton
                    onClick={onDeleteConfirm}
                    background={colors.fieryRed}>
                    {intl.formatMessage({
                        id: 'kingdom.profile.form.delete.account.button.confirm'
                    })}
                </StyledButton>

                <Spacer />

                <StyledButton
                    onClick={onCancel}
                    background="none"
                    border={colors.bbqBrown}
                    color={colors.bbqBrown}>
                    {intl.formatMessage({
                        id: 'form.button.cancel'
                    })}
                </StyledButton>
            </StyledContainer>
        </Modal>
    )
}

const StyledContainer = styled.div`
    padding: ${SPACING.XXL};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`

const StyledInfoContainer = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    flex-wrap: wrap;
`

const StyledIconContainer = styled.div`
    width: 10%;
`

const StyledInfoTextContainer = styled.div`
    width: 90%;
`

const StyledButton = styled(ButtonMedium)`
    width: 100%;
`
